import { Component } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth.service';

// Declare grecaptcha as a global variable
declare const grecaptcha: any;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  // Add your component logic here
  captchaToken = '';
  captchaScore = 0;
  captchaResponse:any = '';
  captchaError:any = '';
  siteKeyEnterprise = '6Le6KCgrAAAAAFTVUF2w0YKyz9CJfeAtEPEbsHI3';

  constructor(private fb: FormBuilder, private authService: AuthService) {
    this.authService.loadRecaptchaScript(true).catch(console.error);

  }

  loginForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
    simulateLowScore: [false],
  });

  handleCaptchaResponse(): void {
    console.log('Captcha token received:', this.captchaToken);
    this.captchaError = '';
    this.authService.login(this.loginForm.value, this.captchaToken).subscribe({
      next: (res:any) => {
        console.log('Auth Success:', res);
        this.captchaResponse = res;
        // this.captchaScore = res.score || 0; // Assuming the response contains a score

      },
      error: (err) => {
        console.error('Auth Failed:', err);
        this.captchaError = err;
        this.captchaResponse = '';

      }
    });
  }

  handleCaptchaError(error: any): void {
    console.error('Captcha error:', error);
    this.captchaError = error;
    this.captchaToken = '';
    this.captchaScore = 0;
    this.captchaResponse = '';
    // Additional logic to handle captcha errors
  }

  onSubmit(simulateLowScore: boolean = false): void {
    if (this.loginForm.valid) {
      console.log('Login Data:', this.loginForm.value);
      // Handle CAPTCHA + login API here
      // this.getCaptchaToken();
      this.runCaptcha();
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  submitReferralWithoutToken(): void {
    console.log('Captcha token received:', this.captchaToken);
    this.captchaResponse = '';
    this.authService.login(this.loginForm.value, '').subscribe({
      next: (res:any) => {
        console.log('Auth Success:', res);
        this.captchaResponse = res;
        // this.captchaScore = res.score || 0; // Assuming the response contains a score

      },
      error: (err) => {
        console.error('Auth Failed:', err);
        this.captchaError = err;
      }
    });
  }
  runCaptcha() {

    this.authService
      .execute(true, 'login')
      .then((token) => {
          this.captchaToken = token; // Store the token
          console.log('Captcha token:', token);
          this.handleCaptchaResponse();
        // Send token to your backend for verification
      })
      .catch(console.error);
  }
}
